import http from './httpService';
/*global API */

const jobsEndpoint = `${API}/api/Jobs`;
const applicantEndpoint = `${API}/api/Applicant`;
const competenceEndpoint = `${API}/api/Competence`;

export function getJob(id) {
  return http.get(jobsEndpoint + '/' + id, id);
}

export function getJobs(paramsTmp) {
  return http.get(jobsEndpoint, {
    params: {
      Title: paramsTmp?.Title,
      Field: paramsTmp?.Field,
      Experience: paramsTmp.Experience?.value,
      EmploymentType: paramsTmp.EmploymentType?.value,
      JobStatus: paramsTmp.JobStatus?.value,
      JobType: paramsTmp.JobType?.value,
      PageNumber: paramsTmp?.PageNumber,
      PageSize: paramsTmp?.PageSize,
      MineOrAllSelected: paramsTmp?.MineOrAllSelected,
    },
  });
}

export function createJob(jobForCreate) {
  return http.post(jobsEndpoint, {
    title: jobForCreate.jobTitle,
    field: jobForCreate.jobField,
    ...jobForCreate,
  });
}

export function updateJob(jobForUpdate) {
  return http.put(jobsEndpoint, {
    title: jobForUpdate.jobTitle,
    field: jobForUpdate.jobField,
    ...jobForUpdate,
  });
}

export function updateJobCompetence(jobCompetenceForUpdateDto, jobId) {
  return http.put(jobsEndpoint + '/competences', {
    JobId: jobId,
    ...jobCompetenceForUpdateDto,
  });
}

export function manageKanbanJobResponsibles(kanbanJobResponsibleDtos) {
  return http.put(jobsEndpoint + '/manageKanbanJobResponsible', kanbanJobResponsibleDtos);
}

export function getAllKanbanResponsiblesJobsSettings(jobId) {
  return http.get(jobsEndpoint + '/getAllKanbanResponsiblesJobsSettings', {
    params: {
      jobId: jobId,
    },
  });
}

export function assignUserToTheJob(jobId, userId, alsoAssignApplications) {
  return http.put(jobsEndpoint + '/assignUser', {
    jobId,
    userId,
    alsoAssignApplications,
  });
}

export function createJobCompetence(jobCompetence) {
  return http.post(jobsEndpoint + '/competences', {
    jobId: jobCompetence.jobId,
    competenceId: jobCompetence.competenceId,
    weight: jobCompetence.weight,
    description: jobCompetence.description,
    type: jobCompetence.type,
  });
}

export function deleteJobCompetence(jobId, competenceId) {
  return http.delete(jobsEndpoint + '/competences', {
    // must use params if backend is retriving parameters like that: RemoveCompetenceFromJob(int jobId, int competenceId) -> without [FromBody]
    params: {
      jobId: jobId,
      competenceId: competenceId,
    },
  });
}

export function createJobQuestion(JC) {
  return http.post(jobsEndpoint + '/questions', {
    jobId: JC.jobId,
    content: JC.content,
    questionType: JC.questionType,
  });
}

export function updateJobQuestion(jobId, questionId, content, questionType) {
  return http.put(jobsEndpoint + '/questions', {
    jobId: jobId,
    questionId: questionId,
    content: content,
    questionType: questionType,
  });
}

export function deleteJobQuestion(jobId, questionId) {
  return http.delete(jobsEndpoint + '/questions', {
    params: {
      jobId: jobId,
      questionId: questionId,
    },
  });
}

export function findMostSuitableJobCandidates(id) {
  return http.get(applicantEndpoint + '/getMostSuitableApplicants', {
    params: {
      jobId: id,
      numApplicants: 5,
    },
  });
}

export function getCompetencesForSelect(type, searchString) {
  return http.get(`${competenceEndpoint}/competencesForSelect`, {
    params: {
      cType: type,
      searchString: searchString,
    },
  });
}

export function updateJobStatus(
  jobId,
  newStatus,
  ignoreNoCompetences,
  changeAllApplicationsToDeclined,
  informApplicantsAboutDeletion
) {
  const tempIgnoreNoCompetences = ignoreNoCompetences ? ignoreNoCompetences : false;
  return http.get(jobsEndpoint + '/publishJobConditionally', {
    params: {
      jobId: jobId,
      newStatus: newStatus,
      ignoreNoCompetences: tempIgnoreNoCompetences,
      changeAllApplicationsToDeclined,
      informApplicantsAboutDeletion,
    },
  });
}

export function getMostSuitableJobs(candidate) {
  candidate.jobCompetences = candidate.jobCompetences.filter((obj) => {
    return obj.competenceId !== '';
  });

  const fileData = new FormData();
  fileData.append('address.city', candidate.city?.value);
  fileData.append('address.countryCode', candidate.selectedCountry?.value);
  fileData.append('address.googlePlaceId', candidate?.googlePlaceId);
  fileData.append('address.lat', candidate?.lat);
  fileData.append('address.latForStreetSearch', candidate?.latForStreetSearch);
  fileData.append('address.lng', candidate?.lng);
  fileData.append('address.lngForStreetSearch', candidate?.lngForStreetSearch);
  fileData.append('address.street', candidate.street?.value);

  fileData.append('firstName', candidate.stepOne.firstName);
  fileData.append('lastName', candidate.stepOne.lastName);
  fileData.append('email', candidate.stepOne.email);
  fileData.append('gender', candidate.stepOne?.gender);
  fileData.append('phoneNumber', candidate.stepOne?.phoneNumber);

  if (candidate.stepOne?.dateOfBirth) {
    fileData.append('dateOfBirth', candidate.stepOne?.dateOfBirth ? candidate.stepOne?.dateOfBirth : undefined);
  }
  fileData.append('introduction', candidate.stepOne?.introduction);
  fileData.append('jobCompetences', candidate?.jobCompetences);
  fileData.append('tempCompetences', JSON.stringify(candidate.jobCompetences));
  fileData.append('cvFile', candidate?.cvForUpload);
  fileData.append('origin', candidate?.origin);

  if (candidate.origin === 'FromAdmin') {
    return http.post(`${applicantEndpoint}/createApplicantFromWizardFromAdmin`, fileData); // candidate inserts its own data
  } else if (candidate.origin === 'FromWizardJobPortal') {
    return http.post(`${applicantEndpoint}/createApplicantFromWizardFromJobPortal`, fileData); // Recruiter inserts a candidate
  }
}

export function reorderJobQuestions(jobForUpdate) {
  const questionIds = jobForUpdate.reorderedQuestions.map((question) => question.id);

  return http.put(jobsEndpoint + '/reorderJobQuestions', {
    jobId: jobForUpdate.jobId,
    questionIds: questionIds,
  });
}
